module.exports = __webpack_public_path__ + "static/media/5-广联达现场生产管理系统.34fb6ec6.png";